<template>
 
      <table class="table table-hover table-striped">
        <thead class="trcss">
          <tr @click.stop >
            <th @click.stopscope="col" v-for="tdata in getTableCaptions" :width="`${tdata.tbcapwidth}`" class="trcss">
              <span>{{ tdata.tbcapdesc}}</span>
          </th>
            
          </tr>
        </thead>
        <tbody>
          <tr v-for="gjob in getjobs" @click.stop >
           <td class="tdlinkcss classgetid">{{ gjob.jobposition}}</td>
            <td class="tdlinkcss" >{{ gjob.jobdepartment}}</td>
            <td class="tdlinkcss" v-for="jrg in getregions"><span v-if="jrg.jobrgid===gjob.jobregion">{{ jrg.country}},{{ jrg.regprov}}</span></td>
            <td class="tdlinkcss">{{ dateTime(gjob.jvaliduntil)}}</td>
            <td class="tdlinkcss"> <router-link :to="{name: 'jobposting', params: {jobid: gjob.jobid}}"><i class="fa-regular fa-circle-down"></i></router-link></td>
          </tr>
        </tbody>
      </table>
</template>
<script>
import moment from 'moment';
export default{
    props: ['getTableCaptions', 'getjobs', 'getregions'],
    
methods: {
async getLinkedID($event) {
        this.$emit('getLinkedID', $event.target.value)
    },
removeClicked() {
  $('table thead th').off('click');
},
dateTime(value) {
      return moment(value).format('YYYY-MMMM-DD');
    },
}

}

</script>
<style scoped>
.tablediv {
    padding-left: 100px;
    padding-right: 100px;
}
.fa-circle-down {
    font-size: 30px;
    color: orangered;
    cursor: pointer;
}
.tablediv {
    padding-top: 100px;
    padding-bottom: 150px;
}
.classgetid {
    cursor: pointer;
}
.trcss {
  color: rgb(138, 56, 27);
}
   /*===================MEDIA SCREENS TAMPLATES===============*/
   /* Extra small devices (phones, 600px and down) */
   @media only screen and (max-width: 600px) {
    .classfilter {
      margin-left: 20px;
      margin-right: 20px;
    }


   }
  
   /* Small devices (portrait tablets and large phones, 600px and up) */
   @media only screen and (min-width: 600px) {
  
   }
   
   /* Medium devices (landscape tablets, 768px and up) */
   @media only screen and (min-width: 768px) {
  
   }
   
   /* Large devices (laptops/desktops, 992px and up) */
   @media only screen and (min-width: 992px) {

   }
   
   /* Extra large devices (large laptops and desktops, 1200px and up) */
   @media only screen and (min-width: 1200px) {
      
   } 
</style>